import { render, staticRenderFns } from "./Forum2025.vue?vue&type=template&id=6d620330&scoped=true&"
import script from "./Forum2025.vue?vue&type=script&lang=js&"
export * from "./Forum2025.vue?vue&type=script&lang=js&"
import style0 from "./Forum2025.vue?vue&type=style&index=0&id=6d620330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d620330",
  null
  
)

export default component.exports